module.exports = __webpack_public_path__ + "assets/block.5e71719f.svg";